// src/constants/patterns.ts
var EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var PASSWORD_PATTERN = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
var LENGTH_8_PATTERN = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
var ONE_LETTER_PATTERN = /^(?=.*[a-zA-Z])/;
var ONE_NUMBER_PATTERN = /^(?=.*\d)/;

export {
  EMAIL_PATTERN,
  PASSWORD_PATTERN,
  LENGTH_8_PATTERN,
  ONE_LETTER_PATTERN,
  ONE_NUMBER_PATTERN
};
//# sourceMappingURL=chunk-L6RQH6MI.mjs.map